export const environment = {
  base_url              : process.env.REACT_APP_BASE_URL as string,
  pubsub                : process.env.REACT_APP_PUBSUB as string,
  nspubsub              : process.env.REACT_APP_NSPUBSUB as string,
  GOOGLE_API_KEY        : process.env.REACT_APP_GOOGLE_API_KEY as string,
  AWS_S3_BUCKET_NAME    : process.env.REACT_APP_AWS_S3_BUCKET_NAME as string,
  AWS_ACCESS_KEY_ID     : process.env.REACT_APP_AWS_ACCESS_KEY_ID as string,
  AWS_SECRET_ACCESS_KEY : process.env.REACT_APP_AWS_SECRET_ACCESS_KEY as string,
};
